import { formatPercent } from "./format";

export const calculateMetricWidth = (count: number, total: number): string => {
    const ratio = (count / total);
    if (ratio > 0 && ratio < 0.01) {
        return "1%";
    }
    return formatPercent(ratio);
};
